<template>
  <div class="modal">
    <div class="modal__overlay" v-show="show">
      <div class="modal__content">
        <button class="modal__close" @click.prevent="close">
          <img src="../assets/images/ico-close.svg" alt="" />
        </button>
        <div class="modal__ico">
          <img src="../assets/images/ico-success.svg" alt="" />
        </div>
        <div class="modal__ttl">The Answers Are Send Successfully</div>
        <div class="modal__sub-ttl">
          Thank you for your responses. We will contact you as soon as possible.
        </div>
        <button class="btn" @click.prevent="close">Done</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "modal",
  data() {
    return {
      show: false,
    };
  },
  methods: {
    open() {
      this.show = true;
      document.body.classList.add("modal-open");
    },
    close() {
      document.body.classList.remove("modal-open");
      this.show = false;
      window.location.href = "/";
    },
  },
};
</script>
